export function injectCssVars(
    vars,
    styleElementId = "dynamic-css-vars",
    cssSelector = ":root",
    wrapInMediaQuery = false,
    mediaMaxWidth = 768
) {
    let styleElement = document.getElementById(styleElementId);
    if(styleElement && Object.keys(vars).length === 0) {
        styleElement.remove();
        return
    }
    if (!styleElement) {
        styleElement = document.createElement("style");
        styleElement.id = styleElementId;
        document.head.appendChild(styleElement);
    }

    const css = Object.entries(vars)
        .map(([key, val]) => `${key}: ${val};`)
        .join("\n");

    let finalCss = `${cssSelector} {\n${css}\n}`;
    if (wrapInMediaQuery) {
        finalCss = `@media (max-width: ${mediaMaxWidth}px) {\n${finalCss}\n}`;
    }

    styleElement.innerHTML = `${finalCss} {\n${css}\n}`;
}

export function removeCssVars(styleElementId = "dynamic-css-vars") {
    let styleElement = document.getElementById(styleElementId);
    if (styleElement) {
        styleElement.remove();
    }
}